export type GrantOpportunityContributor = {
  id: number;
  user_id: number;
  email: string;
  created_at?: string;
};

const jsonHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

function contributorsPath(municipalityId: number, opportunityId: number): string {
  return `/api/v1/municipalities/${municipalityId}/grant_opportunities/${opportunityId}/contributors`;
}

export async function listGrantOpportunityContributors(
  municipalityId: number,
  opportunityId: number,
): Promise<GrantOpportunityContributor[]> {
  const response = await fetch(contributorsPath(municipalityId, opportunityId), {
    credentials: "include",
    headers: { Accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error("Failed to load contributors");
  }
  return response.json();
}

export async function addGrantOpportunityContributor(
  municipalityId: number,
  opportunityId: number,
  userId: number,
): Promise<GrantOpportunityContributor> {
  const response = await fetch(contributorsPath(municipalityId, opportunityId), {
    method: "POST",
    credentials: "include",
    headers: { ...jsonHeaders, "X-CSRF-Token": csrfToken() },
    body: JSON.stringify({
      grant_opportunity_contributor: { user_id: userId },
    }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.errors?.join(", ") ?? "Failed to add contributor");
  }
  return payload;
}

export async function removeGrantOpportunityContributor(
  municipalityId: number,
  opportunityId: number,
  userId: number,
): Promise<void> {
  const response = await fetch(`${contributorsPath(municipalityId, opportunityId)}/${userId}`, {
    method: "DELETE",
    credentials: "include",
    headers: { Accept: "application/json", "X-CSRF-Token": csrfToken() },
  });
  if (!response.ok && response.status !== 204) {
    const payload = await response.json().catch(() => ({}));
    throw new Error(payload.error ?? "Failed to remove contributor");
  }
}
